import React, { Component } from 'react'
import 'styled-components/macro'
import { createClient } from 'contentful'
import { ScaleLoader } from 'react-spinners'

const contentfulClient = createClient({
  space: '62ncoiyebkcj',
  accessToken:
    'b5a47d97003b5a60ad012070580c47d994bfd1d8b9b8744c2256a3ee21bfe90b',
})

const filterResponse = (items, propertyName) =>
  items
    .filter(item => item.sys.contentType.sys.id === propertyName)
    .map(item => item.fields)

export class ContentfulProvider extends Component {
  state = {
    introParagraphs: [],
    fieldInformation: [],
    isLoading: true,
    situations: [],
    behaviorInfo: [],
  }
  componentDidMount() {
    contentfulClient.getEntries({order: 'sys.createdAt'}).then(({ items }) => {
      const introParagraphs = filterResponse(items, 'introTextForskolan')
      const situations = filterResponse(items, 'situation')
      const situationsHeader = filterResponse(items, 'SituationHeaderForskolan')
      const behaviorInfo = filterResponse(items, 'forskolanInforutaBeteende')

      for (var i = 0; i < situations.length; i++) {
        for (var j = 0; j < situations[i].cards.cards.length; j++) {
          situations[i].cards.cards[j].atgarder = situations[i].cards.cards[j].atgarder.map(atgard => {
            return {text: atgard, selected: false}
          })
        }
      }
      this.setState({
        introParagraphs,
        situations,
        situationsHeader,
        behaviorInfo,
        isLoading: false,
      })
    })
  }

  render() {
    const { isLoading, introParagraphs, situations, situationsHeader, behaviorInfo} = this.state
    const { children } = this.props
    if (isLoading) {
      return (
        <div
          css={{ display: 'flex', justifyContent: 'center', marginTop: 150 }}
        >
          <ScaleLoader color="#b8bcbd" />
        </div>
      )
    } else {
      return children({introParagraphs, situations, situationsHeader, behaviorInfo})
    }
  }
}

export default ContentfulProvider
